import script from "./SavedForLater.vue?vue&type=script&setup=true&lang=js"
export * from "./SavedForLater.vue?vue&type=script&setup=true&lang=js"

import "./SavedForLater.vue?vue&type=style&index=0&id=490c05c4&lang=scss&scoped=true"
import "./SavedForLater.vue?vue&type=style&index=1&id=490c05c4&lang=scss"

import exportComponent from "F:\\ubuntuBK\\sombardc\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-490c05c4"]])

export default __exports__